module.exports = __webpack_public_path__ + "static/media/vera-molnar-1974.e32c87cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/vera-molnar-1974.jpg
// module id = 435
// module chunks = 12